import React, { FunctionComponent } from 'react';
import ProtectedRoute from 'components/ProtectedRoute';
import { withRouter } from 'react-router-dom';

import { WithRouterProps } from 'helpers/types';

import CSVCreator from './scenes/CSVCreator';
import CSVStatusChecker from './scenes/CSVStatusChecker';

const CSVExport: FunctionComponent<WithRouterProps> = ({ match }) => (
  <>
    <ProtectedRoute path={`${match.url}/create`} component={CSVCreator} />

    <ProtectedRoute
      path={`${match.url}/status/:uuid`}
      component={CSVStatusChecker}
    />
  </>
);

export default withRouter(CSVExport);
